import {
    IButtonConfirmData,
    IButtonData,
    IDropDownData,
    IFeedbackFormData,
    INotificationFormData
} from "../Types";
import { ICard } from "./ICard";
import { v4 as uuid } from "uuid";
import { getBaseUrl } from "../../../configVariables";

export class NotificationHeroCard implements ICard {
    id: string;
    userData: any;

    constructor(userData: any) {
        this.id = uuid();
        this.userData = userData
    };

    getId() : string {
        return this.id;
    };

    initCard() {
        return (
            {
                "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
                "version": "1.2",
                "type": "AdaptiveCard",
                "body": []
            }
        );
    };

    defaultCard() {
        return this.buildCard(
            "Título",
            "Subtítulo",
            getBaseUrl() + "/image/imagePlaceholder.png",
            "Resúmen",
            [{ id: uuid(), title: "Boton", url: "", type: "Action.OpenUrl" }],
            false,
            { id: "Confirmar", title: "", type: "Action.Submit", data: { submit: "submit.CardConfirm", id: this.id }, style: "positive" },
            false,
            null
        );
    };

    rebuildNotificationCard(data: INotificationFormData) {
        return this.buildCard(
            data.title,
            data.subtitle,
            data.imageLink,
            data.summary,
            data.buttons,
            data.requireConfirmation,
            data.requireConfirmationButton,
            data.sendMeeting,
            data.selectedMeeting
        );
    };

    rebuildFeedbackCard(data: IFeedbackFormData) { };

    buildCard(
        title: string,
        subtitle: string,
        imageLink: string,
        summary: string,
        buttons: IButtonData[],
        requireConfirmation: boolean,
        confirmButton: IButtonConfirmData,
        sendMeeting: boolean,
        meeting: IDropDownData | null
    ) {
        const card: any = this.initCard();

        if (title)
            card.body.push(this.buildTextBlock(title, "large"));
            // card.body.push(this.buildTextBlock(title, "large"));

        if (subtitle)
            card.body.push(this.buildTextBlock(subtitle, "medium"));
        
        if (imageLink)
            card.body.push(this.buildImage(imageLink));
            // card.body.push(this.buildImage(imageLink));

        if (summary)
            card.body.push(this.buildTextBlock(summary, "medium"));

        if (buttons !== null && buttons !== undefined && buttons.length !== 0)
            card.body.push(this.buildButtons(buttons));

        if (requireConfirmation)
            card.body.push(this.buildConfirmButton(confirmButton.title));

        if (sendMeeting && meeting !== null)
            card.body.push(this.buildMeetingButton(meeting))

        return card;
    };

    buildTextBlock(
        value: string | null,
        size: string
    ) {
        return {
            "type": "TextBlock",
            "wrap": true,
            "size": size,
            "text": value
        }
    };

    buildImage(imageUrl: string) {
        return {
            "type": "Image",
            "url": imageUrl
        };
    };

    buildInputText() {
        return {
            "type": "Input.Text",
            "id": "feedback",
            "placeholder": "Dejanos tu Opinion",
            "isMultiline": true
        }
    };

    private buildButtons(buttons: IButtonData[] | null) : any {
        return {
            "type": "ActionSet",
            "actions": buttons,
            "separator": true
        };
    };

    private buildConfirmButton(
        title: string
    ) : any {
        return {
            "type": "ActionSet",
            "actions": [
                {
                    "type": "Action.Submit",
                    "id": "submit",
                    "data": {
                        "submit": "submit.CardNotificationConfirm",
                        "tenantId": this.userData.organization.id,
                        "userId": this.userData.profile.id,
                        "cardNotificationId": this.id,
                    },
                    "title": title,
                    "style": "positive"
                }
            ],
            "separator": true
        };
    };

    private buildMeetingButton(
        meeting: IDropDownData
    ) {
        return {
            "type": "ActionSet",
            "actions": [
                {
                    "type": "Action.Submit",
                    "id": "submit1",
                    "data": {
                        "submit": "submit.CardNotificationMeeting",
                        "tenantId": this.userData.organization.id,
                        "userId": this.userData.profile.id,
                        "meetingId": meeting.key,
                        "cardNotificationId": this.id,
                    },
                    "title": "Enviarme la reunión",
                    "style": "positive"
                }
            ],
            "separator": true
        };
    };
}